import React from 'react'
import { compose } from 'redux'

import { NEUTRAL_COLOURS } from 'constants/colors'

import { withModalService, withModalServiceProps } from 'services/utils/modal'

import { Button, FooterActions, MinimalModalBox, Typography } from 'components'
import { BasicModalProps } from 'modals'

import i18n from 'translations'

import { StyledRoot } from './AiConfirmDiscardModalStyled'

export interface AiConfirmDiscardModalProps {
  onDiscard: () => void
  onFinally: () => void
  onKeep: () => void
}

const AiConfirmDiscardModal: React.FC<BasicModalProps & withModalServiceProps & AiConfirmDiscardModalProps> = ({
  hideModal,
  onDiscard,
  onFinally,
  onKeep,
}) => {
  const handleCancelClick = () => {
    hideModal()
  }

  const handleDiscardClick = () => {
    hideModal()
    onDiscard()
    onFinally()
  }

  const handleKeepClick = () => {
    hideModal()
    onKeep()
    onFinally()
  }

  return (
    <MinimalModalBox>
      <StyledRoot>
        <MinimalModalBox.TopIcon color={NEUTRAL_COLOURS.WHITE} icon="trash" />
        <Typography align="center" fontSize={20} padding="0 0 20px">
          {i18n.t('modals:AiConfirmDiscardModal:content')}
        </Typography>
        <FooterActions noBorder noMargin>
          <FooterActions.Item>
            <Button
              hierarchy="tertiary"
              label={i18n.t('global:Cancel')}
              inverted
              negativeMargins
              onClick={handleCancelClick}
            />
          </FooterActions.Item>
          <FooterActions.Item>
            <Button
              hierarchy="secondary"
              label={i18n.t('global:Discard')}
              inverted
              negativeMargins
              onClick={handleDiscardClick}
            />
          </FooterActions.Item>
          <FooterActions.Item>
            <Button
              color="tertiary"
              label={i18n.t('modals:AiConfirmDiscardModal:keep')}
              inverted
              negativeMargins
              onClick={handleKeepClick}
            />
          </FooterActions.Item>
        </FooterActions>
      </StyledRoot>
    </MinimalModalBox>
  )
}

const enhance = compose(
  withModalService,
)

export default enhance(AiConfirmDiscardModal)
